import { ModuleOutputKeyEnum } from '../constants';
import { ModuleIOValueTypeEnum } from '../constants';
import { FlowNodeOutputTypeEnum } from '../node/constants';
import { FlowNodeOutputItemType } from '../node/types';

export const Output_Template_UserChatInput: FlowNodeOutputItemType = {
  key: ModuleOutputKeyEnum.userChatInput,
  label: 'core.module.input.label.user question',
  type: FlowNodeOutputTypeEnum.hidden,
  valueType: ModuleIOValueTypeEnum.string,
  targets: [],
};

export const Output_Template_Finish: FlowNodeOutputItemType = {
  key: ModuleOutputKeyEnum.finish,
  label: '模块调用结束',
  description: '模块调用结束时触发',
  valueType: ModuleIOValueTypeEnum.boolean,
  type: FlowNodeOutputTypeEnum.source,
  targets: [],
};

export const Output_Template_AddOutput: FlowNodeOutputItemType = {
  key: ModuleOutputKeyEnum.addOutputParam,
  type: FlowNodeOutputTypeEnum.addOutputParam,
  valueType: ModuleIOValueTypeEnum.any,
  label: '',
  targets: [],
};
